<template>
  <CardList v-if="pendingRequest && !decision" class="mb-3">
    <template #header>
      {{ $t("js.candidacy.components.approval_request_list.header",
        { name: candidate.label, date: $d(new Date(pendingRequest.created_at), 'short', props.locale) }) }}
    </template>

    <template #body>
      <RequestCard
        :request="pendingRequest"
        :candidate-image="candidate.image?.url"
        :is-last-one="true"
        :locale="locale"
        :authenticity-token="authenticityToken"
        admin
        @decision-made="decision = $event"
      />
    </template>
  </CardList>

  <div v-if="decision" class="alert alert-success" role="alert">
    {{ $t("js.candidacy.components.approval_request_list.header_success",
      { name: candidate.label, date: $d(new Date(pendingRequest.created_at), 'short', props.locale) }) }}
    <strong>{{ $t(`js.candidacy.components.approval_request_list.decision.${decision}`) }}</strong>
  </div>

  <div v-if="requests.length > 1 || (requests.length === 1 && !pendingRequest)" class="card mb-3">
    <header
      class="card-header h5 border-bottom-0 hstack justify-content-between"
      role="button"
      data-bs-toggle="modal"
      data-bs-target="#requestsModal"
    >
      <span>
        {{ $t("js.candidacy.components.approval_request_list.closed") }}
      </span>
      <AVIcon icon="clock-rotate-left" class="text-dark" />
    </header>
  </div>

  <RequestsModal
    v-if="!!authenticityToken"
    :preloaded="requests"
    :authenticity-token="authenticityToken"
    :candidate-image="candidate.image?.url ? candidate.image?.url : null"
    :locale="locale"
    :candidate-url="candidateUrl"
    admin
  />

</template>

<script setup lang="ts">
import type { ApprovalRequest, PropType, Locale, Candidate } from "@/types";
import CardList from "@/components/shared/CardList.vue";
import RequestCard from "@/components/shared/candidacy/RequestCard.vue";
import RequestsModal from "@/components/shared/candidacy/RequestsModal.vue";
import { ref, computed } from "vue";

const props = defineProps({
  requests: {
    type: Array as PropType<ApprovalRequest[]>,
    required: true,
  },
  candidate: {
    type: Object as PropType<Candidate>,
    required: true,
  },
  locale: {
    type: String as PropType<Locale>,
    required: true,
  },
  authenticityToken: {
    type: String,
    required: true,
  },
  candidateUrl: {
    type: String,
    default: null,
  },
});

const decision = ref<"approved" | "denied" | null>(null);

const pendingRequest = computed(() => props.requests.filter(request => request.decision === "pending")[0]);
</script>
